import type React from "react";
import {Accordion, AccordionDetails, AccordionSummary} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";

type Props = {
    title: React.ReactNode;
    sub?: React.ReactNode;
    /** Controlled when set; otherwise it starts closed and keeps its own state. */
    expanded?: boolean;
    onChange?: (expanded: boolean) => void;
    children: React.ReactNode;
};

/** A section of the bundle page that opens and closes: its whole title row is the toggle. */
export const CollapsibleSection: React.FC<Props> = ({title, sub, expanded, onChange, children}) => (
    <Accordion disableGutters elevation={0} className="ci-collapse" expanded={expanded}
               onChange={(_event, open) => onChange?.(open)}>
        <AccordionSummary expandIcon={<ExpandMore/>} className="ci-collapse-h">
            <span className="ci-collapse-t">
                <h2 className="ci-h2">{title}</h2>
                {sub && <span className="ci-sub">{sub}</span>}
            </span>
        </AccordionSummary>
        <AccordionDetails className="ci-collapse-b">{children}</AccordionDetails>
    </Accordion>
);
